export default __webpack_public_path__ + "static/media/HPSimplified_W_Lt.a84ddef4.woff2";